export const createFbInitMarkup = async (appId: string) => {
    const initScript = document.createElement('script');
    initScript.innerHTML = `
        window.fbAsyncInit = function() {
            FB.init({
                appId: ${appId},
                autoLogAppEvents: true,
                xfbml: false,
                version: 'v3.3'
            });
        };
    `;
    await new Promise((resolve, reject) => {
        initScript.onload = () => {
            resolve(true);
        };

        initScript.onerror = err => {
            reject(err);
        };

        document.body.appendChild(initScript);
    });
};

export const isFbDefined = () => typeof FB !== 'undefined';

const loadFbSdk = async (appId: string, cb?: Function) => {
    createFbInitMarkup(appId);

    const fbSDKScript = document.createElement('script');
    fbSDKScript.src = 'https://connect.facebook.net/en_US/sdk.js';

    await new Promise((resolve, reject) => {
        fbSDKScript.onload = () => {
            if (cb) {
                cb();
            }
            resolve(true);
        };

        fbSDKScript.onerror = err => {
            reject(err);
        };

        document.body.appendChild(fbSDKScript);
    });
};

export default loadFbSdk;
